import React, { useEffect, useState, useMemo } from "react";
import { Table, Accordion } from "@trane/trane-components/dist";
import Select from "components/common/Select";
import { Stack, Typography, Skeleton, Box } from "@mui/material";
import {
  EquipmentListWrapper, SelectBoxContainer, TableWrapper, DataViewHeader, ViewModeSelect,
  MenuListWrapper, NoRecordsDiv, DataPointLoader, MultiSelectWrapper
} from "./styled";
import { withRouter } from "react-router-dom";
import { useQuery, useFetchEquipmentData, useFetchPointsData } from "./useFetchAPIData";
import { FormErrorContainer, ErrorSection } from "components/EnsembleComponents/BACNetComponents/_ModalForms/ViewHubParameters/styled";
import { MdWarning, MdClose } from "react-icons/md";
import { BiLineChart, BiTable } from "react-icons/bi";
import LineChart from "./LineChart";
import ErrorBoundary from "components/common/ErrorBoundaries";
import { MultiSelect } from "react-multi-select-component";

const EquipmentList = ({ location, history }) => {
  const [state, setState] = useState({
    selectedBuilding: null,
    selectedFamilyType: null,
    selectedView: "table",
    tableCellValue:[]
  });

  const query = useQuery(location.search);
  const buildingId = query.get("buildingId");
  const familyTypeId = query.get("familyType");
  const { buildings, familyType, tableColumn, buildingLoader, familyTypeLoader, equipmentListLoader, refetchFamilyTypes,
    refetchEquipmentList, tableRowData, error, updateApiData, dataPointsLoader, sortConfig,fetchNewPoint } = useFetchEquipmentData(buildingId, familyTypeId, location.search);
  const [equipmentIds, setEquipmentIds] = useState([]);
  const [selectedPoints, setPointsValue] = useState([]);
  const [selectedEquipment, setEquipmentValue] = useState([]);
  const { pointsList } = useFetchPointsData(tableRowData, buildingId, familyTypeId, location.search);
  //const {updatedTableData}=fetchNewPointData(tableRowData,);
  const requestData = { controllerId: [], displayId: "", siteId: 0 };
  useEffect(() => {
    if (buildings && buildings.length) {
      const selectedValue = buildings.find(item => `${item.value}` === `${buildingId}`);
      setState(prevState => ({
        ...prevState, selectedBuilding: selectedValue ? selectedValue.value : buildings[0].value
      }));
    }
    if (familyType && familyType.length) {
      const selectedValue = familyType.find(item => `${item.value}` === `${familyTypeId}`);
      setState(prevState => ({
        ...prevState, selectedFamilyType: selectedValue ? selectedValue.value : familyType[0].value
      }));
    }
  }, [buildings, familyType]);

  useEffect(() => {
    if (state.selectedFamilyType) {
      refetchEquipmentList(state.selectedBuilding, state.selectedFamilyType);
    }
  }, [state.selectedFamilyType]);

  useEffect(() => {
    let p = [];
    if (tableRowData.length > 0) {
      tableRowData.forEach((eq) => {

        if (eq.length > 0) {
          p.push(eq[0].id);
        }
      });
    }
    setEquipmentIds(p);
  }, [tableRowData]);

  useEffect(() => {
    setPointsValue(tableColumn);
  }, [tableColumn]);

  useEffect(() => {
    const newEquipmentList = [];
    tableRowData.map((rowItem, index) => {
      if (index !== 0) {
        newEquipmentList.push(rowItem[0]);
      }
      return rowItem;
    });
    setEquipmentValue(newEquipmentList);
  }, [tableRowData]);

  const getSelectedEquipments = useMemo(() => {
    const newEquipmentsList = [];
    const clonedRowData = [...tableRowData];
    clonedRowData.shift();
    selectedEquipment.map(equipmentItem => {
      const elementObj = clonedRowData.filter(rowItem => { return rowItem[0].id === equipmentItem.id });
      if (elementObj && elementObj.length) {
        newEquipmentsList.push(elementObj[0]);
      }
      return equipmentItem;
    });
             
    if (newEquipmentsList && newEquipmentsList.length) {
      newEquipmentsList.unshift([]);
    }
    return newEquipmentsList;
  }, [selectedEquipment, tableRowData]);

  const getSortedData = useMemo(() => {
    const totalRowData = getSelectedEquipments; // Taking all data which is constructed from response
    const { sortedColumnIndex, sortOrder } = sortConfig;
    if (totalRowData && totalRowData.length) {
      let clonedData = [...totalRowData];
      clonedData.shift();
      // Crating a new points list row data based on row and column selections
      const updatedPointsList = [];
      selectedEquipment.map(equipmentItem => {
        const elementObj = clonedData.find(rowItem => { return rowItem[0].id === equipmentItem.id });
        const newRowData = [];
        selectedPoints.map(columnItem => {
          let cellelement = elementObj.filter(z=> z.intlId === columnItem.intlId);
          if (elementObj && elementObj.length && cellelement && cellelement.length > 0) {
              newRowData.push(cellelement[0]);
            } else {
            newRowData.push({
              title: "---",
              value: "---",
              htmlElementId: "",
              intlId: "",
            });
          }
          return columnItem;
        });
        if (newRowData && newRowData.length) {
          updatedPointsList.push(newRowData);
        }
        return equipmentItem;
      });


      if (updatedPointsList && updatedPointsList.length) {
        // sort the row data based sort config values
        updatedPointsList.sort((firstData, secondData) => {
          if ((firstData && firstData[sortedColumnIndex] && secondData && secondData[sortedColumnIndex])
            && firstData[sortedColumnIndex].displayText < secondData[sortedColumnIndex].displayText) {
            return sortOrder === "asc" ? -1 : 1;
          } else if ((firstData && firstData[sortedColumnIndex] && secondData && secondData[sortedColumnIndex])
            && firstData[sortedColumnIndex].displayText > secondData[sortedColumnIndex].displayText) {
            return sortOrder === "asc" ? 1 : -1;
          } else {
            return 0;
          }
        });
        updatedPointsList.unshift([]);
      }
      return updatedPointsList;
    } else {
      return totalRowData;
    }
  }, [tableRowData, selectedEquipment, selectedPoints, sortConfig]);

  const viewModeOptions = [
    {
      label: <MenuListWrapper>
        <BiTable />
        <p>Table</p>
      </MenuListWrapper>,
      value: "table",
    },
    {
      label: <MenuListWrapper>
        <BiLineChart />
        <p>Line Chart</p>
      </MenuListWrapper>,
      value: "chart",
    },
  ];

  const sourceSelection = [
    {
      label: "Buildings",
      id: "building",
      compType: "dropdown",
      value: state.selectedBuilding,
      options: buildings,
      isLoading: buildingLoader,
    },
    {
      label: "Family Type",
      id: "familyType",
      compType: "dropdown",
      value: state.selectedFamilyType,
      options: familyType,
      isLoading: familyTypeLoader,
    },
    {
      label: null,
      id: "viewMode",
      compType: "dropdown",
      value: state.selectedView,
      options: viewModeOptions,
      isLoading: equipmentListLoader,
    },
  ];

  const onChangeSelect = (selectId, value) => {
    if (selectId === "selectedBuilding") {
      refetchFamilyTypes(value, state.selectedFamilyType);
      updateApiData(prevState => ({ ...prevState, familyType: [], handlerId: null }));
      history.push(`/EquipmentList?buildingId=${value}&familyType=${state.selectedFamilyType}`);
      setState(prevState => ({
        ...prevState, [selectId]: value, selectedFamilyType: null, selectedView: "table"
      }));
    } else if (selectId === "selectedFamilyType") {
      updateApiData(prevState => ({ ...prevState, handlerId: null }));
      history.push(`/EquipmentList?buildingId=${state.selectedBuilding}&familyType=${value}`);
      setState(prevState => ({
        ...prevState, [selectId]: value, selectedView: "table"
      }));
    } else {
      setState(prevState => ({
        ...prevState, [selectId]: value
      }));
    }
  }

  const getTableLoaderCom = (rowLength = 6) => {
    const loaderComponent = [];
    for (let i = 0; i < rowLength; i++) {
      loaderComponent.push(
        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
        >
          <Skeleton variant="rounded" width={"60%"} height={45} />
          <Skeleton variant="rounded" width={"60%"} height={45} />
          <Skeleton variant="rounded" width={"60%"} height={45} />
          <Skeleton variant="rounded" width={"60%"} height={45} />
        </Stack>
      );
    }

    return (
      <Stack spacing={1.5}>
        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
          <Skeleton variant="rounded" width={"60%"} height={65} />
          <Skeleton variant="rounded" width={"60%"} height={65} />
          <Skeleton variant="rounded" width={"60%"} height={65} />
          <Skeleton variant="rounded" width={"60%"} height={65} />
        </Stack>
        {loaderComponent}
      </Stack>
    );
  };

  const getEquipmentList = useMemo(() => {
    const newList = [];
    tableRowData.map((item, index) => {
      if (index !== 0) {
        newList.push(item[0]);
      }
      return item;
    });
    return newList;
  }, [tableRowData]);

  const getPointsOption = useMemo(() => {
    const uniqueNames = new Set(tableColumn.map(listItem => { return listItem.value }));
    let newPointsList = pointsList.filter(item => (!uniqueNames.has(item.value)));
    newPointsList = newPointsList.map((pointItem, index) => ({ ...pointItem, columnIndex: tableColumn.length + index }));
    // Spreading default points at first then other points list
    return [...tableColumn, ...newPointsList];
  }, [tableColumn, pointsList]);

  const onChangeElements = (selectedValue) => {
    setEquipmentValue(selectedValue);
  };
  const onChangePoints = (selectedValue) => {
    //let fetchTimeout = null;
    setState(prevState => ({
      ...prevState, selectedView: "table"
    }));
    const updatedTableData=[...tableRowData];
    updatedTableData.map(objectVal => {

      selectedValue.map(val => {
        if (val.dataObjectName) {
          requestData.displayId = val.displayId;
          requestData.siteId = parseInt(val.siteId ? val.siteId : -1);
          val?.dataObjectName.map(i => {
            let cellelement = objectVal.filter(z=>z.id === i.id);
            if (cellelement.length > 0) {
              let htmlElementId = `${i.id}-${i.actualDisplayId}`;
              if (objectVal.filter(i=>i.htmlElementId === htmlElementId).length < 1){
              requestData.controllerId.push(i.id);
              objectVal.push({
                title: "---",
                id: i.id,
                intlId:i.actualDisplayId,
                htmlElementId: `${i.id}-${i.actualDisplayId}`,
                displayText: "---",
                value: '---',
               
              });
            }
            }
            return i;
          });
        }
        return val;
      });
      return objectVal;
    });
    setState(prevState => ({
      ...prevState, selectedView: "table", tableCellValue:updatedTableData
    }));
    setPointsValue(selectedValue);
    fetchNewPoint(requestData,updatedTableData);
    
  };


  function getSelectedPointNames() {
    let sPoints = [];
    let allowedDataTypes = ["A", "B", "M"]; //analogy, binary, multistate

    selectedPoints.forEach((s) => {
      if (s.type && s.type !== null && s.type === 'data')
        sPoints.push(s.label);
      else if (s.dataType && s.dataType != null && allowedDataTypes.indexOf(s.dataType) >= 0)
        sPoints.push(s.defaultName);
    });

    return sPoints;
  }


  return (
    <>
      <EquipmentListWrapper>
        <Typography
          component="h6"
          variant="h6"
          style={{ color: "#333", fontFamily: "Verdana", fontWeight: "bold" }}
        >
          Equipment List
        </Typography>
        <Accordion
          id="data-source-selection"
          data={[
            {
              header: "Data Source",
              content: (
                <Stack
                  direction="row"
                  justifyContent="flex-start"
                  alignItems="center"
                  spacing={3}
                >
                  {/* <Stack
                      direction="row"
                      justifyContent="flex-start"
                      alignItems="center"
                      spacing={0.2}
                    >
                      <Skeleton variant="rounded" width={35} height={35} />
                      <Skeleton variant="rounded" width={200} height={35} />
                    </Stack> */}
                  <SelectBoxContainer>
                    <Select
                      {...sourceSelection[0]}
                      onChange={e => onChangeSelect("selectedBuilding", e.target.value)}
                    />
                  </SelectBoxContainer>
                  <SelectBoxContainer>
                    <Select
                      {...sourceSelection[1]}
                      onChange={e => onChangeSelect("selectedFamilyType", e.target.value)}
                    />
                  </SelectBoxContainer>
                </Stack>
              ),
            },
          ]}
        />
        <Accordion
          id="data-points-selection"
          data={[
            {
              header: "Selected Points and Equipments",
              content: (
                <MultiSelectWrapper
                  direction="row"
                  justifyContent="flex-start"
                  alignItems="center"
                  spacing={3}
                >
                  <Box className="multi-select-wrapper">
                    <Typography >
                      Points
                    </Typography>
                    <MultiSelect
                      labelledBy="Select Points"
                      options={getPointsOption}
                      value={selectedPoints}
                      onChange={onChangePoints}
                      ClearSelectedIcon={null}
                    />
                  </Box>
                  <Box className="multi-select-wrapper">
                    <Typography>
                      Equipments
                    </Typography>
                    <MultiSelect
                      labelledBy="Select Equipments"
                      options={getEquipmentList}
                      value={selectedEquipment}
                      onChange={onChangeElements}
                      ClearSelectedIcon={null}
                    />
                  </Box>
                </MultiSelectWrapper>
              ),
            },
          ]}
        />
        <Accordion
          id="equipment-list-data"
          data={[
            {
              header: <DataViewHeader><label>Equipments</label>
                <ViewModeSelect>
                  {
                    dataPointsLoader ? <DataPointLoader title="Fetching data points">
                      <div className="spinner" aria-busy="true">
                        <span className="bubble1"></span>
                        <span className="bubble2"></span>
                        <span className="bubble3"></span>
                      </div>
                    </DataPointLoader> : null
                  }
                  <Select
                    {...sourceSelection[2]}
                    onChange={e => onChangeSelect("selectedView", e.target.value)}
                  />
                </ViewModeSelect>
              </DataViewHeader>,
              content: equipmentListLoader ? getTableLoaderCom() :
                state.selectedView === "chart" ?
                  <LineChart equipmentIds={equipmentIds} buildingId={state.selectedBuilding} familyType={state.selectedFamilyType} selectedPoints={getSelectedPointNames()} />
                  : (
                    <TableWrapper>
                      {
                        tableRowData && tableRowData.length && selectedEquipment && selectedEquipment.length ? <ErrorBoundary>
                          <Table header={selectedPoints} rows={getSortedData} />
                        </ErrorBoundary> :
                          <><ErrorBoundary>
                            <Table header={selectedPoints} rows={[]} /></ErrorBoundary>
                            <NoRecordsDiv>No Records Found</NoRecordsDiv></>
                      }
                    </TableWrapper>
                  ),
            },
          ]}
        />
      </EquipmentListWrapper>
      {
        error ? <ErrorSection left="8%">
          <FormErrorContainer>
            <MdWarning />
            <Box>
              <b>Internal application error. Please try refreshing the page.</b>
              <p>{error}</p>
            </Box>
          </FormErrorContainer>
          <div>
            <MdClose onClick={() => updateApiData(prevState => ({ ...prevState, error: "" }))} />
          </div>
        </ErrorSection> : null
      }
    </>);
};

export default withRouter(EquipmentList);
